import { theme as defaultTheme } from "@mindlercare/ui-web";
import { styled } from "styled-components";

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${defaultTheme.PADDING.LG};
  padding: ${defaultTheme.PADDING.LG};
`;
